module.exports = __webpack_public_path__ + "static/media/home10.9d8ffee3.jpg";